export default __webpack_public_path__ + "static/media/database.9318f74c.png";